(function() {

	"use strict"

	angular.module( 'ATMGurus' )

	.directive( 'labelPrint', [
		'$window',
		'$compile',
		'$http',
		'$timeout',
		"$interpolate",
		"Checkout",
		"User",
		function( $window, $compile, $http, $timeout, $interpolate, Checkout, User) {
			return {
				restrict: 'EA',
				template: "<button class='btn btn-secondary btn-xs print-label' ng-click='openWindow()'>PRINT LABEL</button>",
				scope: {
					orderId: '='
				},
				controller: ["$scope", "$element", "$attrs", function( $scope, $element, $attrs ) {
					$scope.openWindow = function() {

						$scope.labelData = {
							shipping: Checkout.address,
							contact: Checkout.getContactDetails(),
							tritonAddress: {
								address1: "179 Pinewood Road",
								address2: "Repair Center",
								zipcode: 11263,
								city: "El Paso",
								state: "TX"
							}
						}

						var labelWindow = window.open('', 'rma_label_window');

						let tpl = require("Templates/bits/label.html")
						$(labelWindow.document.body).append($interpolate(tpl)($scope))
					}
				}]
			}
		}
	]);
})()



// WEBPACK FOOTER //
// ./src/app/directives/labelPrint.js